import auth from '@/router/auth'
import CategoryBlogIndex from '@/components/category-blogs/Index'
import CategoryBlogCreate from '@/components/category-blogs/Create'
import CategoryBlogUpdate from '@/components/category-blogs/Update'
import CategoryBlogShow from '@/components/category-blogs/Show'

export default [
  {
    path: '/category-blogs',
    name: 'category-blogs-index',
    component: CategoryBlogIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/category-blogs/create',
    name: 'category-blogs-create',
    component: CategoryBlogCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/category-blogs/update/:id',
    name: 'category-blogs-update',
    component: CategoryBlogUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/category-blogs/show/:id',
    name: 'category-blogs-show',
    component: CategoryBlogShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/category-blogs/router.js